var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-4xl py-20 mx-auto flex-grow flex flex-col"},[(_vm.document)?_c('iframe',{staticClass:"w-full flex-grow",attrs:{"src":_vm.url}}):_c('BadDocRoute')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }